export default "__VITE_ASSET__10a6cd9e__"